import { render, staticRenderFns } from "./GeracaoAutomatica.vue?vue&type=template&id=c850e61a&scoped=true&"
import script from "./GeracaoAutomatica.vue?vue&type=script&lang=js&"
export * from "./GeracaoAutomatica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c850e61a",
  null
  
)

export default component.exports